export default __webpack_public_path__ + "ee4eb3515cfc86f7e70033814968ea95.png";